// extracted by mini-css-extract-plugin
export var cardTitle = "_c9-1";
export var commentBubble = "_c9-e";
export var commentForm = "_c9-a";
export var commentInput = "_c9-b";
export var commentLabel = "_c9-d";
export var commentPrompt = "_c9-9";
export var csatCard = "_c9-0";
export var feedbackSection = "_c9-7";
export var starDisabled = "_c9-6";
export var starEmpty = "_c9-5";
export var starFilled = "_c9-4";
export var starWrapper = "_c9-3";
export var starsContainer = "_c9-2";
export var submittedComment = "_c9-c";
export var thankYouText = "_c9-8";